import styled from 'styled-components';
import {
  compose,
  color,
  typography,
  position,
  border,
  background,
  space,
  flexbox,
  grid,
  layout,
  shadow,
} from 'styled-system';

const Wrapper = styled.div(
  compose(
    color,
    typography,
    position,
    border,
    background,
    space,
    flexbox,
    grid,
    layout,
    shadow
  )
);

Wrapper.defaultProps = {
  maxWidth: '100%',
};

export default Wrapper;
